import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-171">
      <div className="container mx-auto max-w-4xl" data-id="element-172">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-173">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#eab308]" data-id="element-174">
            Presentamos BIODECODIFICACION Integral
          </h2>

          <p className="text-xl md:text-2xl text-gray-400 font-serif italic mb-8" data-id="element-175">
            El programa formativo completo de Academia Holística Argentina
          </p>

          <div className="space-y-4 text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-176">
            <p data-id="element-177">
              Este no es un resumen de YouTube ni un PDF con frases bonitas.
            </p>

            <p className="text-white font-medium" data-id="element-178">
              Es una formación estructurada en 6 volúmenes donde vas a aprender
              a leer el lenguaje de tu cuerpo, entender el origen emocional de
              los síntomas más frecuentes y aplicar herramientas concretas para
              comenzar tu proceso de sanación desde la raíz.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4" data-id="element-179">
            <span className="bg-white/5 border border-white/20 rounded-full px-5 py-2 text-white font-medium text-sm md:text-base backdrop-blur-sm" data-id="element-180">
              📱 100% Digital
            </span>
            <span className="bg-white/5 border border-white/20 rounded-full px-5 py-2 text-white font-medium text-sm md:text-base backdrop-blur-sm" data-id="element-181">
              ⏰ A tu ritmo
            </span>
            <span className="bg-white/5 border border-white/20 rounded-full px-5 py-2 text-white font-medium text-sm md:text-base backdrop-blur-sm" data-id="element-182">
              ♾️ Acceso de por vida
            </span>
          </div>
        </div>
      </div>
    </section>;
}